import { render, staticRenderFns } from "./TemplateLogin.vue?vue&type=template&id=99e201c8&scoped=true&"
import script from "./TemplateLogin.vue?vue&type=script&lang=ts&"
export * from "./TemplateLogin.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateLogin.vue?vue&type=style&index=0&id=99e201c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e201c8",
  null
  
)

export default component.exports